import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { dayOfWeekName, timeFormat } from "../../../util/DateUtil";
import { porDiaEHorario } from "../cronogramaUtil";

/** Lista das aulas que ocupam o local, por dia. */
const CronogramaLocalTable = ({ cronogramas }) => {
  const ordenados = [...cronogramas].sort(porDiaEHorario);

  if (ordenados.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" textAlign="center" py={6}>
        Nenhuma aula neste local.
      </Typography>
    );
  }

  return (
    <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
      <Table size="small" sx={{ minWidth: 640 }} aria-label="Aulas do local">
        <TableHead>
          <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
            <TableCell>Dia</TableCell>
            <TableCell>Aula</TableCell>
            <TableCell>Disciplina</TableCell>
            <TableCell>Turma</TableCell>
            <TableCell>Professor</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {ordenados.map((c, index) => {
            const novoDia = index === 0 || ordenados[index - 1].diaSemana !== c.diaSemana;
            return (
              <TableRow
                key={c.codigo ?? `${c.diaSemana}-${c.cronogramaAula?.codigo}-${index}`}
                hover
                sx={novoDia && index > 0 ? { "& td": { borderTop: 2, borderTopColor: "divider" } } : undefined}
              >
                <TableCell sx={{ fontWeight: novoDia ? 600 : 400, color: novoDia ? "text.primary" : "text.disabled" }}>
                  {dayOfWeekName(c.diaSemana)}
                </TableCell>
                <TableCell>
                  {c.cronogramaAula?.ordemAula}ª · {timeFormat(c.cronogramaAula?.horarioInicio)} -{" "}
                  {timeFormat(c.cronogramaAula?.horarioFim)}
                </TableCell>
                <TableCell>{c.tdp?.disciplina?.descricao ?? "--"}</TableCell>
                <TableCell>{c.tdp?.turma?.descricao ?? "--"}</TableCell>
                <TableCell>{c.tdp?.usuario?.nome ?? "--"}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CronogramaLocalTable;
